


















import { listFactory } from '@/main/pages';
import { deleteButton } from '@/main/utils/tableOperations';
import { apiProvider } from '@/modules/uzaverka/uzaverkaSkladu/api';

import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	data() {
		return {
			extraButtons: {
				...deleteButton((e: any, cells: any) => this.deleteItem(cells[this.table!.cellNames!.idColumn])),
			},
		};
	},
	methods: {
		async uzaverka() {
			this.startLoading();

			try {
				await apiProvider.provestUzaverku(this.filter);
			} finally {
				this.endLoading();
			}
		},
	},
});
